module.exports = __webpack_public_path__ + "img/img27.9e6c3600.svg";